import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'
import { ApplicationDisclosure } from './interfaces/ClientApplication'

/**
 * Get application disclosures by application id.
 * @param  {number | string} [id] Application id.
 * @param  {AbortController} [abortController] Optional abort controller.
 * @return {ApplicationDisclosure[]} Array of application disclosure data.
 */
export default async function getApplicationDisclosures(
    id: number | string,
    abortController?: AbortController,
): Promise<ApplicationDisclosure[]> {
    try {
        if (!id) {
            throw new Error('Application ID cannot be empty')
        }

        const { data } = await axios.get<ApplicationDisclosure[]>(
            `${config.API_BASE_URL}/api/v3/client-application/${id}/disclosures/`,
            {
                signal: abortController?.signal,
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get application disclosures: ${axiosError.message}`,
            axiosError,
            { application: { id } },
        )

        throw axiosError
    }
}
